import { Button } from "antd";
import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/hooks";
import { doLogout } from "src/store/slices/UserSlice";
import '../css/navi-menu.css';
import { NaviMenuItem } from "./NaviMenuItem";

export const Header: FC = () => {

    const user = useAppSelector(state => state.user);

    const dispatch = useAppDispatch();

    const navigate = useNavigate();

    useEffect(() => {
        if (!user.accessToken) {
            navigate("/");
        }
    }, [user])

    const handleLogoutBtn = () => {
        dispatch(doLogout());
    }

    return (
        <div
            className="left-column">
            <nav className="navi-menu">
                {/* <NaviMenuItem id="dashboard" title="Dashboard" link_to="dashboard" /> */}
                <NaviMenuItem id="requests" title="Запросы" link_to="requests" />
                <NaviMenuItem id="clients" title="Клиенты" link_to="clients" />
                <NaviMenuItem id="contacts" title="Контакты" link_to="contacts" />
                <NaviMenuItem id="contacts" title="Карта" link_to="map" />
                {/* <NaviMenuItem id="competencies" title="Competencies" link_to="competencies" /> */}
                {/* <NaviMenuItem id="customers" title="Customers" link_to="customers" /> */}
            </nav>
            {/* <div style={{ width: 'auto' }}> */}
            <Button type="primary" danger
                style={{ margin: '20px auto 0px', display: 'block' }}
                color="red"
                onClick={handleLogoutBtn}>
                Выход
            </Button>
            {/* </div> */}
        </div>
    )
}
